module.exports = __webpack_public_path__ + "./images/49d2495ebdf1d6357cc0dc74bdc763ae.webp";